import { Injectable } from '@angular/core';
import { AUTH_TOKEN_KEY, UserService } from '../../app/services/user.service';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService  {

    constructor(private router: Router, private userService: UserService, private activeRouter: ActivatedRoute) {
    }

    canActivate(next: ActivatedRouteSnapshot): boolean {
        if (window.location.href.includes('login/rewards') || window.location.href.includes('login/redeem-rewards') || window.location.href.includes('login/vouchers')) {
            return true;
        }
        const isLoggedIn = !!localStorage.getItem(AUTH_TOKEN_KEY);
        if (isLoggedIn) {
            this.userService.loadUserInstance();
        }
        if (isLoggedIn && this.userService &&
            this.userService.currentUser &&
            this.userService.currentUser.access_token &&
            !this.userService.bypassGuard &&
            !this.userService.currentUser.isWhatsappOnboardingFlowEnabled &&
            !!this.ifRedirectToKashFlow()) {

            const redirectTo = next.queryParams['redirectTo'];
            if (redirectTo) {
                this.redirectToLocation(redirectTo);
            } else {
                // Redirect to the home page if 'redirectTo' is not found
                this.router.navigate(['/home']);
            }

            return false;
        }
        this.userService.afterLogoutRituals();
        return true;
    }

    private ifRedirectToKashFlow() {
        return this.activeRouter.queryParams.subscribe((param) => {
            const gettingAuthForKashflow = param['getAuthForKashFlow'];
            if (gettingAuthForKashflow) {
                return false;
            }
        })
    }

    //if user is logged in and redirecTo param is present
    private redirectToLocation(redirectTo) {
        // Redirect to the specified URL
        const decodedUrl = decodeURIComponent(redirectTo);
        if (decodedUrl.includes(environment.olympus_collection_url)) {
            // Create a URL object
            const url = new URL(decodedUrl);
            // Get the hostname (including the protocol)
            const hostname = url.origin + '/';
            const searchParam = url.search;
            if (hostname === environment.olympus_collection_url) {
                const access_token = this.userService.currentUser.access_token;
                const kashflowUrl = hostname + `validate-token` + searchParam + `&token=${access_token}`;
                window.location.href = kashflowUrl;
            }
        } else {
            this.router.navigateByUrl(decodedUrl);
        }
    }
}
